import * as React from "react";
import { Map } from "ol";
import { FC, useEffect, useState } from "react";
import { AdvancedDropdown } from "../Coordinates/AdvancedDropdown";
import { ISingleRowList } from "../Coordinates/DropdownList";
import { boundrieTypes } from "../config";
import { DropdownType } from "../enums";
import { useMapContext } from "../../Contexts/MapContext";
import i18next from "i18next";
import { roundToPlaceValue } from "../utils";
import { getPointResolution } from "ol/proj";
import "./ScaleWidget.scss";

interface IScaleWidget {
    map: Map;
    onSizeChange?: (mobile: boolean, expanded: boolean) => void;
    colapsedByDefault?: boundrieTypes;
}

interface ISizeState {
    mobile: boolean;
    expanded: boolean;
}

let DEFAULT_DPI;
const inchesPerMeter = 1000 / 25.4;

export const ScaleWidget: FC<IScaleWidget> = (props: IScaleWidget) => {
    const { configA } = useMapContext();

    DEFAULT_DPI = configA.defaultDpi || 96.198892;

    const getScales = () => {
        const view = props.map.getView();
        return view
            .getResolutions()
            .map((res, i) => {
                const pointResolution = getPointResolution(view.getProjection(), res, view.getCenter(), "m");
                return {
                    label: i,
                    value: roundToPlaceValue(parseFloat(pointResolution.toString()) * inchesPerMeter * DEFAULT_DPI)
                };
            })
            .filter((r) => r);
    };

    const scales = configA.mapLods ? configA.mapLods.map((lod, i) => ({ label: i, value: lod.scale })) : getScales();

    const getSizeState = (): ISizeState =>
        document.body.scrollWidth > 660 && isExpandAllowed(props.colapsedByDefault)
            ? { mobile: false, expanded: true }
            : { mobile: true, expanded: false };

    //@ts-ignore
    const [scale, setScale] = useState<number>(document.mapScale);
    const [sizeState, setSizeState] = useState<ISizeState>(getSizeState());

    useEffect(() => {
        document.addEventListener("resize", () => checkSize());
        document.addEventListener("moveend", (e) => onMoveEnd(e));

        return () => {
            document.removeEventListener("resize", () => checkSize());
            document.removeEventListener("moveend", (e) => onMoveEnd(e));
        };
    }, []);

    const onMoveEnd = (e) => setScale(e.detail);

    const changScale = (attribute: ISingleRowList) =>
        props.map.getView().animate({ zoom: Number(attribute.label), duration: 500 });

    const checkSize = () => {
        const sizeStateNew = getSizeState();
        if (sizeStateNew.mobile !== sizeState.mobile || sizeStateNew.expanded !== sizeState.expanded) {
            setSizeState(sizeStateNew);
            props.onSizeChange && props.onSizeChange(sizeStateNew.mobile, sizeStateNew.expanded);
        }
    };

    return (
        <div className="scale-widget">
            <AdvancedDropdown
                title={i18next.t("coordinates.scaleTitle")}
                attributes={scales}
                text={i18next.t("coordinates.scale") + " 1:" + (scale || "")}
                alwaysOpen={false}
                closeOnSubmit={true}
                selectedValue={scale}
                type={DropdownType.SingleLine}
                clicked={(at) => changScale(at as ISingleRowList)}
                chevronClass={["esri-icon-up", "esri-icon-down"]}
            />
            <div className="scale-right-border"></div>
        </div>
    );
};

function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

function isExpandAllowed(rule: boundrieTypes | undefined) {
    if (!rule || rule === "none" || (rule === "iframe" && !inIframe())) {
        return true;
    }
    return false;
}
